// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay--Yt6SP {
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 500;

  color: white;
}[dir] .overlay--Yt6SP {
  margin: 20px 0;
}

.message--k7_9Z {
  position: relative;
  pointer-events: auto;
}

[dir] .message--k7_9Z {
  background: rgb(39, 46, 51);
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
}

[dir=ltr] .message--k7_9Z {
  padding: 20px 60px 20px 40px;
}

[dir=rtl] .message--k7_9Z {

  padding: 20px 40px 20px 60px;
}

[dir] .message--k7_9Z p {
  margin: 0;
}

.close--XZh_W {
  position: absolute;
  top: 6px;
  font-size: 32px;
  color: white !important;
}

[dir] .close--XZh_W {
  background: none;
  border: none;
  cursor: pointer;
}

[dir=ltr] .close--XZh_W {
  right: 10px;
}

[dir=rtl] .close--XZh_W {
  left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/DataUnavailableOverlay/styles.css"],"names":[],"mappings":"AAAA;EAEE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;;EAEZ,YAAY;AACd,CARA;EACE,cAAc;AAOhB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AAOtB;;AATA;EAGE,2BAA2B;EAG3B,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AATA;EAKE,4BAA4B;AAI9B;;AATA;;EAKE,4BAA4B;AAI9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EAIR,eAAe;EAEf,uBAAuB;AACzB;;AATA;EAIE,gBAAgB;EAChB,YAAY;EAEZ,eAAe;AAEjB;;AATA;EAGE,WAAW;AAMb;;AATA;EAGE,UAAW;AAMb","sourcesContent":[".overlay {\n  margin: 20px 0;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 500;\n\n  color: white;\n}\n\n.message {\n  position: relative;\n  pointer-events: auto;\n  background: rgb(39, 46, 51);\n\n  padding: 20px 60px 20px 40px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.message p {\n  margin: 0;\n}\n\n.close {\n  position: absolute;\n  top: 6px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 32px;\n  cursor: pointer;\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay--Yt6SP`,
	"message": `message--k7_9Z`,
	"close": `close--XZh_W`
};
export default ___CSS_LOADER_EXPORT___;
